import {createListResponseSchema} from 'src/feature/bite/domain'
import z from 'zod'

export const StoreListItemSchema = z.object({
  id: z.string(),
  name: z.string().nullable(),
  mccCode: z.string().nullable(),
  status: z.number().nullable(),
  createdOn: z.string(),
  typeID: z.string().nullable(),
  typeName: z.string().nullable(),
  cityName: z.string().nullable(),
  no: z.string().nullable().optional(),
  // id: z.string(),
  // externalId: z.string().nullable(),
  // extraId: z.string().nullable(),
  // name: z.string(),
  // businessName: z.string().nullable(),
  // taxId: z.string(),
  // merchantTradeName: z.string(),
  // mcc: z.string().nullable(),
  // groupId: z.string().nullable(),
  // chainId: z.string().nullable(),
  // contactEmail: z.string(),
  // contactPhone: z.string(),
  // employeeId: z.string().nullable(),
  // webSite: z.string().nullable(),
  // latitude: z.string().nullable(),
  // longitude: z.string().nullable(),
  // isSeasonPeriod: z.boolean(),
  // seasonStartDate: z.string(),
  // seasonEndDate: z.string(),
  // countryId: z.string(),
  // cityId: z.string(),
  // regionId: z.string(),
  // addressLine: z.string(),
  // zipCode: z.string(),
  // phone: z.string(),
  // email: z.string(),
  // agreementDate: z.string(),
  // createdOn: z.string(),
  // createdBy: z.string().nullable(),
  // modifiedOn: z.string(),
  // modifiedBy: z.string().nullable(),
  // stateCode: z.number(),
  // statusCode: z.number(),
  // contactFirstName: z.string(),
  // contactLastName: z.string(),
  // workingOpenHour: z.string(),
  // workingCloseHour: z.string(),
  // contactGender: z.number(),
})

export const StoreListSchemaResponse = createListResponseSchema(StoreListItemSchema.array())

export type StoreListItem = z.infer<typeof StoreListItemSchema>
export type StoreList = z.infer<typeof StoreListSchemaResponse.shape.response>
export type StoreListResponse = z.infer<typeof StoreListSchemaResponse>

const filterListSchema = z.array(
  z.object({
    operator: z.number(),
    key: z.string(),
    value: z.array(z.string()),
    logicalOp: z.number().optional(),
    childFilters: z.array(z.object({})).optional(),
  })
)

const orderListSchema = z.array(
  z.object({
    type: z.number(),
    key: z.string(),
  })
)

const pagingSchema = z.object({
  currentPageNumber: z.number(),
  pageSize: z.number(),
})

const searchSchema = z.object({
  value: z.string(),
  keyList: z.array(z.string()),
})

export const listFilterSchema = z.object({
  filterList: filterListSchema,
  orderList: orderListSchema,
  paging: pagingSchema,
  search: searchSchema,
})

export type ListFilter = z.infer<typeof listFilterSchema>
export type FilterList = z.infer<typeof filterListSchema>
